import { render, staticRenderFns } from "./NoticeTab.vue?vue&type=template&id=08d80e95&"
import script from "./NoticeTab.vue?vue&type=script&lang=js&"
export * from "./NoticeTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports